export class RelatedSlickSlider {
	constructor(node, opts) {
		this.node = node;
		this.opts = { ...opts };
		if (!this.node) return;

		this.slickInitialized = false;
		this.handleResize = this.handleResize.bind(this);

		this.jslick = "";
		this.slideCount = parseInt(this.node.dataset.slideCount, 10) || 0; // Get the slide count from the data attribute
		// Initial check
		this.handleResize();

		// Listen for resize
		window.addEventListener("resize", this.handleResize);
	}

	initSlider() {
		if (
			this.slickInitialized ||
			this.slideCount <= 1 ||
			jQuery(this.node).hasClass("slick-initialized")
		)
			return;
		this.jslick = jQuery(this.node).slick({
			mobileFirst: true,
			slidesToShow: 1.1,
			slidesToScroll: 1,
			prevArrow: false,
			nextArrow: false,
			dots: true,
			appendDots: this.node,
			infinite: false,
			variableWidth: false,
			customPaging: (slider, i) =>
				`<button class="dot" data-slide="${i + 1}"></button>`,
			responsive: [
				{
					breakpoint: 601,
					settings: "unslick",
				},
			],
		});
		this.slickInitialized = true;
	}

	unInitializeSlick() {
		if (this.slickInitialized) {
			this.slickInitialized = false;
		}
	}

	handleResize() {
		if (window.innerWidth <= 600) {
			this.initSlider();
		} else {
			this.unInitializeSlick();
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	jQuery(document).ready(() => {
		document.querySelectorAll(".related-content").forEach((node) => {
			new RelatedSlickSlider(node, { ...node.dataset });
		});
	});
});
